import request from '@/api/request'

export function queueMonitorGetSqsMetrics() {
  return request({
    url: '/queueMonitor/sqsMetrics',
    method: 'get',
  })
}
